var _defs, _path, _rect, _path2, _path3, _path4, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVortexInsurance01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438 416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;stroke-miterlimit:10;}.a{stroke:#09B2C9;stroke-width:8px;}.b{fill:#09B2C9;}.c{stroke:#a3c7e9;stroke-width:9px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M326.83,103.25H314.3V92.16a2.9,2.9,0,0,0-2.89-2.89H246.18a2.9,2.9,0,0,0-2.9,2.89v11.09H120.54a2.89,2.89,0,0,0-2.9,2.89V256a2.89,2.89,0,0,0,2.9,2.89H326.83a2.89,2.89,0,0,0,2.89-2.89V106.14A2.89,2.89,0,0,0,326.83,103.25Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 106.77,
    y: 135.31,
    width: 233.83,
    height: 171.65,
    rx: 3.19
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M202.07,150.72V123.08a3.19,3.19,0,0,0-3.19-3.19H127a3.19,3.19,0,0,0-3.19,3.19v27.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M308.45,331.86C368.23,302,376.59,229.7,376.59,229.7c-40.34,0-68.14-35.36-68.14-35.36s-27.8,35.36-68.15,35.36C240.3,229.7,248.67,302,308.45,331.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M344.05,261.9a35.6,35.6,0,1,1-35.6-35.6A35.6,35.6,0,0,1,344.05,261.9Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 289.71,
    y1: 261.9,
    x2: 327.18,
    y2: 261.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 308.45,
    y1: 243.16,
    x2: 308.45,
    y2: 280.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVortexInsurance01);
export default __webpack_public_path__ + "static/media/Vortex_Insurance-01.b6d1e222ee7c1022bd16dd0b55f504f6.svg";
export { ForwardRef as ReactComponent };